import { createFileRoute } from '@tanstack/react-router';
import { dealDirectionParamValues, type DealDirectionParam } from '../-direction';
import { assertDealLedgerEnabled } from '../../-utils/assertDealLedgerEnabled';
export const Route = createFileRoute('/_staff/deal/add/$direction/')({
  params: {
    parse: params => ({
      direction: params.direction as DealDirectionParam
    }),
    stringify: params => ({
      direction: params.direction
    })
  },
  beforeLoad: ({
    params
  }) => {
    assertDealLedgerEnabled();
    if (!dealDirectionParamValues.includes(params.direction as DealDirectionParam)) {
      throw new Error(`Invalid direction: ${params.direction}`);
    }
  },
  component: () => null
});